import Vue from 'vue';
import Component from './View.vue';

Vue.component(Component.name, Component);
